import axios, { AxiosResponse } from 'axios';
import { MeansCash } from '../transactions';
import { ApiResponse, GetReportResponse, zps_ea_war } from '../zps';

export type IRejects = {
  denominationType: string;
  position: number;
  type: string;
};

export type IRefId = {
  code: number;
  eid: number;
  period: number;
};

export type IBankTransaction = {
  account: string;
  bankid: number;
  billsInDoubt: number;
  cashIn: MeansCash[];
  cid: number;
  code: number;
  coinsInDoubt: number;
  dateTime: string;
  dateTimeSent: string;
  depositor: string;
  eid: number;
  entid: number;
  envTotals: number;
  etvid: number;
  gid: number;
  hostStatusCode: number;
  hostTransactionID: string;
  msid: number;
  nseq: number;
  period: number;
  reason: string;
  refID?: IRefId;
  rejects: IRejects[];
  shift: number;
  sid: number;
  status: string;
  type: string;
  value: number;
  valueDis: number;
  valueRec: number;
};

export interface IBankTransactionResponse extends ApiResponse {
  transactions: IBankTransaction[];
  payment: boolean;
  totalRows: number;
}

export const fetchBankTransactionList = (
  controller: AbortController,
  begin: string,
  end: string,
  entid: number,
  sid: number,
  offset: number,
  limit: number,
  totalRows: boolean,
  uid?: number
): Promise<AxiosResponse<IBankTransactionResponse>> => {
  const url =
    `${zps_ea_war}/tb420/transaction?begin=${begin}&end=${end}&entid=${entid}&sid=${sid}&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
    `${uid ? `&uid=${uid}` : ''}`;

  return axios.get<IBankTransactionResponse>(url, { signal: controller.signal });
};

export const fetchBankTransactionReport = (
  format: string,
  eid: number,
  period: number,
  code: number,
  controller: AbortController
): Promise<AxiosResponse<GetReportResponse>> => {
  const url = `${zps_ea_war}/tb420/transaction/report?format=${format}&eid=${eid}&period=${period}&code=${code}`;

  return axios.get<GetReportResponse>(url, { signal: controller.signal });
};
